export const parseOrderedCompareDomainsFromKeys = (keys: unknown): string[] => {
    if (typeof keys !== "string") {
        return [];
    }
    return keys
        .split(",")
        .map((domain) => domain.trim())
        .filter(Boolean);
};

export const getNumericSharesFromSiteOrigins = (
    siteOrigins: unknown,
    orderedCompareDomains: readonly string[],
): number[] | undefined => {
    if (!siteOrigins || typeof siteOrigins !== "object" || Array.isArray(siteOrigins)) {
        return undefined;
    }

    const originsRecord = siteOrigins as Record<string, unknown>;

    if (orderedCompareDomains.length > 0) {
        return orderedCompareDomains.map((domain) => {
            const shareValue = originsRecord[domain];
            return typeof shareValue === "number" ? shareValue : 0;
        });
    }

    return Object.values(originsRecord).filter((value): value is number => typeof value === "number");
};
